module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_3016.65095516.png";